import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Modal, Group, Spinner } from '@economic/gaudi';
import { t, tBB, useLocalization } from '../../../../shared/components/l10n/l10n';
import { RouteDisclosure } from '../../../../shared/components/RouteDisclosure';
import { redirectToLegacyPage } from '@economic/react-app';

export default function CopyAccrualsDialog() {
    const disclosure = <RouteDisclosure routeTrigger={'#copy-accruals'} />;
    const navigate = useNavigate();
    const textsLoading = useLocalization(textIds);
    const location = useLocation();
    const { opsaetning, debitorNr, fakturaNr, fakturaStatus } = location.state || ({} as any);

    if (textsLoading) {
        return <Spinner />;
    }

    function hide() {
        navigate(location.pathname);
    }

    function handleCopyAccruals() {
        redirectToLegacyPage(
            `${process.env.ECONOMIC_PATH}/include/DataForms/KopierBogfoertFaktura.asp?returnertil=104&ops=${opsaetning}&debid=${debitorNr}&fakturanr=${fakturaNr}&returfaktype=${fakturaStatus}&mul=-1&accruals=True`
        );

        hide();
    }

    function handleCredit() {
        redirectToLegacyPage(
            `${process.env.ECONOMIC_PATH}/include/DataForms/KopierBogfoertFaktura.asp?returnertil=104&ops=${opsaetning}&debid=${debitorNr}&fakturanr=${fakturaNr}&returfaktype=${fakturaStatus}&mul=-1&accruals=False`
        );

        hide();
    }

    return (
        <Modal
            aria-label={t`COPY_ACCRUALS_FOR_INVOICE_HEADER`}
            disclosure={disclosure}
            size="dialog"
            onHide={hide}
            hideOnEsc={false}
            hideOnClickOutside={false}
            showCloseButton={false}>
            <Modal.Header>{t`COPY_ACCRUALS_FOR_INVOICE_HEADER`}</Modal.Header>
            <Modal.Content>{tBB(`COPY_ACCRUALS_FOR_INVOICE_MESSAGE`)}</Modal.Content>
            <Modal.Footer>
                <Group>
                    <Button onClick={handleCredit} appearance="ghost">
                        {t`COPY_ACCRUALS_FOR_INVOICE_NO`}
                    </Button>
                    <Button appearance="primary" autoFocus onClick={handleCopyAccruals}>
                        {t`COPY_ACCRUALS_FOR_INVOICE_YES`}
                    </Button>
                </Group>
            </Modal.Footer>
        </Modal>
    );
}

const textIds = [
    'COPY_ACCRUALS_FOR_INVOICE_HEADER',
    'COPY_ACCRUALS_FOR_INVOICE_MESSAGE',
    'COPY_ACCRUALS_FOR_INVOICE_YES',
    'COPY_ACCRUALS_FOR_INVOICE_NO',
];
